export default __webpack_public_path__ + "static/media/Kunal.7f811d93.jpeg";